"use client";
import { makeStyles } from "@fluentui/react-components";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import { ArchivedActivityList } from "../components/activity/ArchivedActivityList";
import { DraftActivityList } from "../components/activity/DraftActivityList";
import { PublishedActivityList } from "../components/activity/PublishedActivityList";
import { ConstrainedContent } from "../components/layout/ConstrainedContent";
import { TabView, TabViewInfo } from "../components/TabView";

const useClasses = makeStyles({
  root: {
    overflow: "visible",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    height: "100%",
  },
});

function ActivitiesPage() {
  const classes = useClasses();
  const { t } = useTranslation();

  const [searchParams] = useSearchParams();

  const view = searchParams.get("view") ?? "published";

  const tabInfos: TabViewInfo[] = [
    { text: t("published"), value: "published" },
    { text: t("drafts"), value: "drafts" },
    { text: t("archivedListTab"), value: "archived" },
  ];

  return (
    <div className={classes.root}>
      <ConstrainedContent>
        <h1>{t("activities")}</h1>
        <TabView
          tabInfos={tabInfos}
          defaultTabValue={view}
          onTabChange={() => undefined}
          defaultSortField="modified"
        />
      </ConstrainedContent>

      {view === "published" && <PublishedActivityList />}

      {view === "drafts" && <DraftActivityList />}

      {view === "archived" && <ArchivedActivityList />}
    </div>
  );
}

export default ActivitiesPage;
